// @flow
import { componentFactory } from '../component-factory';

export const Title = componentFactory('h1', () => ({
  fontFamily: 'Gilroy, "Open Sans", OpenSans, Arial, "Helvetica Neue", Helvetica, sansSerif',
  fontSize: '1.8em',
  color: '#2f4a75',
  fontWeight: '500',
}));
